var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.6667C17.2374 22.6667 18.4243 22.175 19.2995 21.2998C20.1747 20.4247 20.6663 19.2377 20.6663 18C20.6663 16.6667 19.9997 15.4 18.6663 14.3333C17.333 13.2667 16.333 11.6667 15.9997 10C15.6663 11.6667 14.6663 13.2667 13.333 14.3333C11.9997 15.4 11.333 16.6667 11.333 18C11.333 19.2377 11.8247 20.4247 12.6998 21.2998C13.575 22.175 14.762 22.6667 15.9997 22.6667Z",
    stroke: "#E7000B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodGroup);
export default __webpack_public_path__ + "static/media/bloodGroup.4c26f56750ebb7477c57f69b9ef1a6b8.svg";
export { ForwardRef as ReactComponent };